<template>
  <el-select :disabled="disabled" filterable v-model="useModel" :clearable="true" placeholder="Select" v-loading="isLoading">
    <el-option v-for="userRole in userAuthorizationRoleList" :value="userRole.id" :label="userRole.userDivRoleName" :key="userRole.id">
    </el-option>
  </el-select>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  props: {
    inputModel: {
      default: 0
    },
    clearable: {
      default: false
    },
    disabled: {
      default: false
    }
  },
  data () {
    return {
      userAuthorizationRoleList: Array,
      isLoading: true
    }
  },
  computed: {
    useModel: {
      get: function () {
        return this.inputModel
      },
      set: function (modifiedValue) {
        this.$emit('input', modifiedValue)
      }
    }
  },
  methods: {
    fetchUserAuthorizationRoleList () {
      this.isLoading = true
      var call = '/GetPEAUserAuthorizationRoles'
      this.$axios.get(call).then(response => {
        this.userAuthorizationRoleList = response.data
        this.isLoading = false
      }).catch(reject => {
        this.isLoading = false
        helperMethods.showNotification(this.$parent.$parent.$parent.$parent.$parent.$parent, 'Error getting User Authorization Roles', reject.body, 'error', 30000, '')
      })
    }
  },
  created () {
    this.fetchUserAuthorizationRoleList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
